<app-dashboard-card
	[title]="title"
	icon="pi pi-check-circle"
>
	<div *ngIf="loading" class="dashboard-state">
		Loading auto-completed tasks...
	</div>

	<div
		*ngIf="!loading && error"
		class="dashboard-state dashboard-state-error"
	>
		Unable to load auto-completed tasks.
	</div>

	<ng-container *ngIf="!loading && !error && autoCompletion">
		<!-- ============================================= -->
		<!-- SINGLE DAY                                    -->
		<!-- ============================================= -->

		<div
			*ngIf="!multiDay && tasks.length > 0"
			class="auto-completed-table-wrapper"
		>
			<table class="auto-completed-table single-day-table">
				<thead>
				<tr>
					<th>Task</th>
					<th>Action</th>
				</tr>
				</thead>

				<tbody>
				<tr *ngFor="let task of visibleTasks">
					<td>
						{{ task.reportTypeName }}
					</td>

					<td>
						<button
							type="button"
							class="auto-completed-view-link"
							(click)="onViewTask(task.taskInstanceId)"
						>
							View
						</button>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<!-- ============================================= -->
		<!-- MULTI DAY                                     -->
		<!-- ============================================= -->

		<div
			*ngIf="multiDay && groupedTasks.length > 0"
			class="auto-completed-table-wrapper"
		>
			<table class="auto-completed-table multi-day-table">
				<thead>
				<tr>
					<th>Task</th>
					<th>Auto-Completed</th>
					<th>Reasons</th>
					<th>View</th>
				</tr>
				</thead>

				<tbody>
				<tr *ngFor="let task of visibleGroupedTasks; trackBy: trackByReportTypeCode">
					<td class="task-name">
						{{ task.reportTypeName }}
					</td>

					<td class="task-count">
						{{ task.count }}
					</td>

					<td class="task-reasons">
						<div class="reason-list">
								<span
									*ngFor="let reason of task.reasons"
									class="reason-pill"
								>
									{{ reason }}
								</span>
						</div>
					</td>

					<td class="task-view">
						<button
							type="button"
							class="auto-completed-view-link"
							(click)="onViewBreakdown(task.reportTypeCode)"
						>
							View
						</button>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div
			*ngIf="tasks.length === 0"
			class="dashboard-state"
		>
			No tasks were auto-completed for the selected period.
		</div>

		<div
			*ngIf="hasMoreTasks"
			class="auto-completed-expand"
		>
			<button
				type="button"
				class="auto-completed-expand-link"
				(click)="toggleExpanded()"
			>
				{{ expanded ? 'Show less' : 'Show all' }}

				<i
					class="pi"
					[ngClass]="
						expanded
							? 'pi-chevron-up'
							: 'pi-chevron-down'
					"
				></i>
			</button>
		</div>

		<!-- ============================================= -->
		<!-- OUTCOMES                                      -->
		<!-- ============================================= -->

		<div class="outcomes-section">

			<div class="outcomes-list">
				<div
					*ngFor="let outcome of outcomeRows"
					class="outcome-row"
				>
					<div class="outcome-label">
						{{ outcome.label }}
					</div>

					<div class="outcome-value">
						{{ outcome.value }}
					</div>

					<div class="outcome-track">
						<div
							class="outcome-bar"
							[ngClass]="outcome.className"
							[style.width.%]="getOutcomeWidth(outcome.value)"
						></div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>

	<div
		*ngIf="!loading && !error && !autoCompletion"
		class="dashboard-state"
	>
		Auto-completion data is unavailable for the selected period.
	</div>
</app-dashboard-card>
